import React, { useEffect, useState } from 'react';
import { CustomTable } from '../../../../Components/Admin/CustomTable';
import { camposFormulario, camposFormularioCrear, columns } from './Helpers/listarPokemonHelper';
import { useListarPokemones, useCrearPokemon, useEliminarPokemon } from '../../../../Hooks/Admin';
import { useSelectTipoPokemon, useSelectPokemonOriginal } from '../queries/useSelectsPokemon';

export const ListarPokemon = ({ moveTab }) => {
    const [tipos, setTipos] = useState(null);

    const tiposPrincipal = useSelectTipoPokemon();
    const preevoluciones = useSelectPokemonOriginal();

    const opcionesTipoPrincipal = tiposPrincipal.data ?? [];
    const opcionesTipoSecundario = tiposPrincipal.data ?? [];
    const opcionesPreevolucion = preevoluciones.data ?? [];
    const opcionesPokemonOriginal = preevoluciones.data ?? [];

    useEffect(() => {
        // Aquí podrías cargar tipos de Pokémon si tienes un endpoint
        setTipos([]);
    }, []);

    return (
        <CustomTable
            camposFilter={camposFormulario(tipos)}
            queryListar={useListarPokemones}
            camposAgregar={camposFormularioCrear({
                tiposPrincipal: opcionesTipoPrincipal,
                tiposSecundario: opcionesTipoSecundario,
                preevoluciones: opcionesPreevolucion,
                pokemonesOriginales: opcionesPokemonOriginal
            })}
            camposFormularioModal={camposFormularioCrear({
                tiposPrincipal: opcionesTipoPrincipal,
                tiposSecundario: opcionesTipoSecundario,
                preevoluciones: opcionesPreevolucion,
                pokemonesOriginales: opcionesPokemonOriginal
            })}
            columns={columns(moveTab)}
            queryCrear={useCrearPokemon}
            accionesList={false}
            canDelete={true}
            queryBorrarFila={useEliminarPokemon}
            perPage={10}
        />
    );
};
